import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

/**
 * Apps 卡片骨架屏
 */
export const AppsCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className="group relative size-full overflow-hidden">
      <div className={cn('relative h-46 w-35 overflow-hidden rounded-md md:h-91 md:w-68', className)}>
        {/* 主要内容骨架屏 */}
        <Skeleton className="size-full" />
      </div>
    </div>
  )
}

/**
 * Apps 卡片网格骨架屏
 */
function AppsGridSkeleton() {
  return (
    <div className="grid w-full grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-[repeat(auto-fit,minmax(300px,1fr))]">
      {Array.from({ length: 18 }).map((_, index) => (
        <AppsCardSkeleton key={index} className="aspect-[3/4] !size-full" />
      ))}
    </div>
  )
}

/**
 * Apps 页面内容区域骨架屏
 * 在服务端数据加载完成前显示（不包含 Header）
 */
export function AppsContentSkeleton() {
  return (
    <div className="page-container">
      <AppsGridSkeleton />
    </div>
  )
}
